import { SectionNamePacks } from '@bpm-web-app/components/pages';

export default SectionNamePacks;
